// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AddStoreListResult } from "@store/Framework/Store/Pages/StoreLists/Handlers/AddStoreList";
import StoreListsState from "@store/Framework/Store/Pages/StoreLists/StoreListsState";
import { GetStoreListsApiParameter } from "@store/Services/StoreListService";
import { Draft } from "immer";

const initialState: StoreListsState = {
    getStoreListsParameter: { page: 1 },
};

const actions = {
    "Pages/StoreLists/UpdateLoadParameter": (
        draft: Draft<StoreListsState>,
        action: { parameter: GetStoreListsApiParameter },
    ) => {
        draft.getStoreListsParameter = { ...draft.getStoreListsParameter, ...action.parameter };

        for (const key in draft.getStoreListsParameter) {
            const value = (<any>draft.getStoreListsParameter)[key];

            // remove empty parameters
            if (value === "" || value === undefined) {
                delete (<any>draft.getStoreListsParameter)[key];
            }
        }

        for (const key in action.parameter) {
            // go back to page 1 if any other parameters changed
            if (draft.getStoreListsParameter.page && draft.getStoreListsParameter.page > 1 && key !== "page") {
                draft.getStoreListsParameter.page = 1;
            }
        }
    },
    "Pages/StoreLists/BeginAddStoreList": (draft: Draft<StoreListsState>) => {},
    "Pages/StoreLists/CompleteAddStoreList": (
        draft: Draft<StoreListsState>,
        action: { result: AddStoreListResult },
    ) => {},
    "Pages/StoreLists/BeginDeleteStoreList": (draft: Draft<StoreListsState>) => {},
    "Pages/StoreLists/CompleteDeleteStoreList": (draft: Draft<StoreListsState>) => {},
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreListsActions = Parameters<typeof reducer>[1];
export default reducer;
